import axios from "axios";
import qs from 'qs'
import moment from 'moment';
const state = {
  campaigns: [],
  groupCampaigns: [],
  campaign: {},
  segments: [],
  loading: false,
  groupCampaign: {},
  campaignSelectList: [],
  companySelectList: [],
  merchantCampaigns: [],
  merchantCampaign: {},
};

const getters = {
  allGroupCampaigns: (state) => state.groupCampaigns,
  allCampaigns: (state) => state.campaigns,
  campaignData: (state) => state.campaign,
  loading: (state) => state.loading,
  allSegments: (state) => state.segments,
  groupCampaignData: (state) => state.groupCampaign,
  campaignSelectList: (state) => state.campaignSelectList,
  companySelectList: (state) => state.companySelectList,
  allMerchantCampaigns: (state) => state.merchantCampaigns,
  merchantCampaign: (state) => state.merchantCampaign,
  allSegmentTypes: () => [
    { value: '', label: "Hepsi" },
    { value: 'NoSegment', label: 'Segment Yok' },
    { value: 'ActiveUsers', label: 'Aktif Kullanıcılar' },
    { value: 'Lapsing', label: 'Vazgeçenler' },
    { value: 'Churn', label: 'Ayrılanlar' },
    { value: 'DiscountCode', label: 'İndirim Kodu' },
    { value: 'ReferenceCode', label: 'Referans Kodu' },
    { value: 'NewCommers', label: 'Yeni Gelenler' },
    { value: 'FreeTrail', label: 'Ücretsiz Deneme' },
  ]
};

const actions = {
  getCampaigns({ commit }, query) {
    commit("setLoading", true);
    const queryString = qs.stringify({
      page: query.pageNumber,
      size: query.pageSize,
      search: query.search,
      campaignType: query.filterByCampaign,
      isActive: query.isActive,
      segmentType: query.filterBySegment,
      subscriptionType: query.filterBySubscriptionType,
      startDate: query.startDate ? moment(query.startDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : query.startDate,
      endDate: query.endDate ? moment(query.endDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : query.endDate,
      campaignGroupId: query.campaignGroupId
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });
    return axios
      .get(
        `/api/panel/reader-user-campaign/campaign-list?${queryString}`
      )
      .then((response) => {
        commit("setCampaigns", response.data.payload.items);
        commit("setLoading", false);

        return response.data.payload;
      });
  },
  getGroupCampaigns({ commit }, query) {
    const queryString = qs.stringify({
      page: query.pageNumber,
      size: query.pageSize,
      search: query.searchGroup,
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });
    commit("setLoading", true);
    return axios
      .get(
        `/api/panel/reader-user-campaign/campaign-group-list?${queryString}`
      )
      .then((response) => {
        commit("setGroupCampaigns", response.data.payload.items);
        commit("setLoading", false);

        return response.data.payload;
      });
  },
  getCampaign({ commit }, campaign) {
    return axios
      .get(`/api/panel/reader-user-campaign/campaign-detail/${campaign.id}`)
      .then((response) => {
        commit("setCampaign", response.data.payload);
        return response.data.payload;
      });
  },
  getGroupCampaign({ commit }, groupCampaignId) {
    return axios
      .get(`/api/panel/reader-user-campaign/campaign-group/${groupCampaignId}`)
      .then((response) => {
        commit("setGroupCampaign", response.data.payload);
        return response.data.payload;
      });
  },
  getSegments({ commit }) {
    return axios
      .get(`/api/public/get-enum/SegmentType`)
      .then((response) => {
        commit("setSegments", response.data.payload);
        return response.data.payload;
      });
  },
  addCampaign({ commit }, campaign) {
    campaign.endDate = campaign.endDate ? moment(campaign.endDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss') : campaign.endDate
    const formData = new FormData();
    Object.keys(campaign).map((key) => {
      if (campaign[key]) {
        formData.append(key, campaign[key])
      }
    })
    return axios
      .post(`/api/panel/reader-user-campaign/create-campaign`, formData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  addSubCampaigns({ commit }, campaign) {
    const formData = new FormData();
    Object.keys(campaign).forEach((key) => {

      if (key.toLowerCase().endsWith('url')) return;
      if (campaign[key] == 'null') return;
      if (campaign[key]) {
        if (key === "companyList") {
          if (Array.isArray(campaign[key]) && campaign[key].length)
            campaign[key].forEach((value) => formData.append(key, value));
          return;
        }
        formData.append(key, campaign[key]);

      }
    });
    return axios
      .post(`/api/panel/reader-user-campaign/create-group-campaigns`, formData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  addCampaignGroup({ commit }, campaignGroup) {
    return axios
      .post(`/api/panel/reader-user-campaign/create-campaign-group`, campaignGroup)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  updateCampaignStatus({ commit }, campaign) {
    const formData = new FormData();
    formData.append('id', campaign.id)
    formData.append('active', campaign.isActive)

    return axios
      .put(`/api/panel/reader-user-campaign/update-campaign-active`, formData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  updateCampaignVisibility({ commit }, campaign) {

    const formData = new FormData();
    formData.append('id', campaign.id)
    formData.append('shown', campaign.isShown)
    return axios
      .put(`/api/panel/reader-user-campaign/update-campaign-visibility`, formData)
      .then((response) => {
        return response.data;
      });
  },
  updateCampaign({ commit }, campaign) {
    console.log("campaign", campaign);
    const formData = new FormData();
    Object.keys(campaign).map((key) => {
      if (campaign[key]) {
        formData.append(key, campaign[key])
      }
    })
    return axios
      .put(`/api/panel/reader-user-campaign/update-campaign`, formData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  addCoupon({ commit }, couponObj) {
    return axios
      .post(`/api/panel/reader-user-campaign/add-coupon-code`, couponObj)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  exportCampaignCodes({ commit }, exportData) {

    axios
      .get(
        `/api/panel/reader-user-campaign/check-code-is-created/${exportData.campaignId}`
      )
      .then((response) => {
        if (response.data.processStatus === "ERROR") {
          alert(response.data.friendlyMessage.message);
          return;
        }
        axios({
          url: `/api/panel/reader-user-campaign/export-campaign-code-list/${exportData.campaignId}`,
          method: "GET",
          responseType: "blob" // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `${exportData.campaignName.replaceAll(" ", "") +
            "_" +
            new Date().toLocaleDateString("tr-TR").replaceAll(".", "")
            }.xlsx`
          );
          document.body.appendChild(link);
          link.click();
        });
      });
  },
  getCampaignSelectList({ commit }, campaignSelectListData) {
    commit("setLoading", true);
    return axios
      .get(
        `/api/panel/reader-user-campaign/campaign-selected-list?search=${campaignSelectListData.search
        }`
      )
      .then((response) => {
        commit("setCampaignSelectList", response.data.payload);
        commit("setLoading", false);

        return response.data.payload;
      });
  },
  getCompanySelectList({ commit }, query) {
    commit("setLoading", true);
    const queryString = qs.stringify({
      page: query.pageNumber,
      size: query.pageSize,
      search: query.search,
    },
      {
        skipNulls: true,
        filter: (prefix, value) => (value !== '' ? value : undefined),
      });
    return axios
      .get(
        `/api/panel/company/get-company-select-list?${queryString}`
      )
      .then((response) => {
        commit("setCompanySelectList", response.data.payload.items);
        commit("setLoading", false);

        return response.data.payload;
      });
  },
  updateSubCampaigns({ commit }, updateSubCampaigns) {
    return axios
      .put(`/api/panel/reader-user-campaign/update-sub-campaigns/${updateSubCampaigns.id}`,
        updateSubCampaigns.subCampaignList
      )
      .then((response) => {
        return response.data;
      });
  },
  updateCampaignGroup({ commit }, updateCampaignGroup) {
    return axios
      .put(`/api/panel/reader-user-campaign/update-campaign-group/${updateCampaignGroup.id}`, updateCampaignGroup)
      .then((response) => {
        return response.data;
      });
  },
  addMerchantCampaign({ commit }, campaign) {
    const formData = new FormData();
    Object.keys(campaign).map((key) => {
      formData.append(key, campaign[key])
    })

    return axios
      .post(`/api/panel/merchant-campaign`, formData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  getMerchantCampaigns({ commit }, campaignPageData) {
    commit("setLoading", true);
    const queryString = qs.stringify({
      page: campaignPageData.pageNumber,
      size: campaignPageData.pageSize,
      search: campaignPageData.search,
      campaignType: campaignPageData.filterByCampaign,
      isActive: campaignPageData.filterByStatus,
      // segmentType: campaignPageData.filterBySegment,
      subscriptionType: campaignPageData.filterBySubscriptionType,
      // &campaignGroupId=${campaignPageData.campaignGroupId}`
      startDate: campaignPageData.startDate ? moment(campaignPageData.startDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : campaignPageData.startDate,
      endDate: campaignPageData.endDate ? moment(campaignPageData.endDate, 'DD/MM/YYYY').format('YYYY-MM-DDTHH:mm:ss') : campaignPageData.endDate,
    },
      {
        skipNulls: true, // Exclude null and undefined values
        filter: (prefix, value) => (value !== '' ? value : undefined), // Exclude empty strings
      });

    return axios
      .get(
        `/api/panel/merchant-campaign/list?${queryString}`
      )
      .then((response) => {
        if (response.data.payload.items) {
          response.data.payload.items.map((campaign => {
            if (campaign.title.length > 50) {
              campaign.title = campaign.title.substring(0, 50) + '...';
            }
            if (campaign.description.length > 50) {
              campaign.description = campaign.description.substring(0, 50) + '...';
            }
            if (campaign.shortDescription.length > 50) {
              campaign.shortDescription = campaign.shortDescription.substring(0, 50) + '...';
            }
          }))
          commit("setMerchantCampaigns", response.data.payload.items);
        }
        commit("setLoading", false);

        return response.data.payload;
      });
  },
  getMerchantCampaign({ commit }, campaign) {
    return axios
      .get(`/api/panel/merchant-campaign/${campaign.id}`)
      .then((response) => {
        if (response.data.payload.endDate) {
          response.data.payload.endDate = response.data.payload.endDate.substring(0, 10)
        }
        commit("setMerchantCampaign", response.data.payload);
        return response.data.payload;
      });
  },
  updateMerchantCampaign({ commit }, campaign) {
    const formData = new FormData();
    Object.keys(campaign).map((key) => {
      if (key === 'linkText' && !campaign['link']) {
        return;
      }
      if (campaign[key]) {
        formData.append(key, campaign[key])
      }
    })
    return axios
      .put(`/api/panel/merchant-campaign`, formData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  updateMerchantCampaignStatus({ commit }, campaign) {
    let campaignData = {
      id: campaign.id,
      active: campaign.active
    };

    return axios
      .put(`/api/panel/merchant-campaign/update-active`, campaignData)
      .then((response) => {

        console.log("response", response);
        return response.data;
      });
  },
  updateMerchantCampaignVisibility({ commit }, campaign) {
    let campaignData = {
      id: campaign.id,
      shown: campaign.shown
    };

    return axios
      .put(`/api/panel/merchant-campaign/update-visibility`, campaignData)
      .then((response) => {
        return response.data;
      });
  },
};

const mutations = {
  setCampaigns: (state, campaigns) => {
    state.campaigns = campaigns;
  },
  setGroupCampaigns: (state, groupCampaigns) => {
    state.groupCampaigns = groupCampaigns;
  },
  setCampaign: (state, campaign) => {
    campaign.endDate = campaign.endDate.substring(0, 10)
    state.campaign = campaign;
  },
  setLoading(state, value) {
    state.loading = value;
  },
  setSegments(state, segments) {
    state.segments = segments;
  },
  setGroupCampaign: (state, groupCampaign) => {
    state.groupCampaign = groupCampaign;
  },
  setCampaignSelectList: (state, campaignSelectList) => {
    state.campaignSelectList = campaignSelectList;
  },
  setCompanySelectList: (state, companySelectList) => {
    state.companySelectList = companySelectList;
  },
  setMerchantCampaigns: (state, merchantCampaigns) => {
    state.merchantCampaigns = merchantCampaigns
  },
  setMerchantCampaign: (state, merchantCampaign) => {
    state.merchantCampaign = merchantCampaign;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
